import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { v4 as uuidv4 } from "uuid"
import { IoReload } from "react-icons/io5"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import {
  addHeldOrder,
  changeDeliveryType,
  deleteHeldOrder,
  replaceOrder,
  setOrderTableNumber
} from "@redux"
import { moment } from "utils"
import { IconButton, Tooltip } from "components"
import classes from "./HeldOrderTableRowRetrieveButton.module.scss"

const HeldOrderTableRowRetrieveButton = props => {
  const { heldOrder, setOpenRetrievModal } = props

  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const order = useSelector(state => state.order)

  const deliveryType =
    useSelector(state =>
      state.deliveryInfo.deliveryType
    )

  const holdCurrentOrder = () => {
    const isCartEmpty =
      order.items.length === 0 &&
      order.combos.length === 0

    if (isCartEmpty) return

    const heldOrder = {
      _id: uuidv4(),
      date: moment().toISOString(),
      deliveryType,
      items: order.items,
      combos: order.combos,
      tableNumber: order.tableNumber
    }

    dispatch(
      addHeldOrder(heldOrder)
    )
  }

  const handleRetrieve = () => {
    dispatch(
      deleteHeldOrder(heldOrder._id)
    )

    holdCurrentOrder()

    const newOrder = {
      servingDate: moment(0).toISOString(),
      tableNumber: heldOrder.tableNumber,
      items: heldOrder.items,
      combos: heldOrder.combos
    }

    dispatch(
      replaceOrder(newOrder)
    )

    dispatch(
      setOrderTableNumber(
        heldOrder.tableNumber
      )
    )

    dispatch(
      changeDeliveryType(
        heldOrder.deliveryType
      )
    )

    setOpenRetrievModal(false)
  }

  const isLtr =
    i18n.dir(i18n.language) === "ltr"

  return (
    <Tooltip title={t("بازیابی_سفارش")}>
      <span>
        <IconButton
          icon={IoReload}
          size={22}
          color="var(--color-success)"
          className={clsx(classes["button"], isLtr && classes["button-ltr"])}
          onClick={handleRetrieve}
        />
      </span>
    </Tooltip>


  )
}

export default HeldOrderTableRowRetrieveButton